import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/nhl-legacy-team-stacking/actions';

class PPLinesChecking extends Component {
    onChange(ppLine, isChecked) {
        this.props.dispatch(Action.setPPLinesForStackNumber(
            {[ppLine]: isChecked},
            this.props.stackNumber,
        ));
    }
    render() {
        const {stackNumber, stacking} = this.props;
        const ppLines = stacking.getPPLinesByStackNumber(stackNumber);

        return (
            <div className="chk-group-container">
                <strong className="chk-group-title">PP Lines:</strong>
                <div className="chk-group">
                    {Object.keys(ppLines).map(ppLine => (
                        <label key={ppLine}>
                            <input
                                type="checkbox"
                                checked={ppLines[ppLine]}
                                onChange={e => ::this.onChange(ppLine, e.target.checked)}/>
                            <span>{ppLine}</span>
                        </label>
                    ))}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        nhlLegacyTeamStacking,
    } = state;

    return {
        stacking: nhlLegacyTeamStacking,
    }
}

export default connect(mapStatesToProps)(PPLinesChecking);
